import data from "../../utils/constants/data.json";
import PostLayout from "../../layout/post-layout/PostLayout";
import CommonComponent from "../common-component/CommonComponent";

const FeedComponent = () => {
    const { feedData } = data;

    const feedLayout = (
        <div>
            {/* <PostLayout description={"Checkout the Gemini Pro model in action."} search={true} pin={true} /> */}

            {Object.keys(data).map((res) => {
                /* for data to be pinned */
                return Object.keys(data[res]).map((val) => {
                    if (data[res][val].pin) {
                        return (
                            <PostLayout
                                key={data}
                                date={data[res][val].date}
                                pin={data[res][val].pin}
                                description={data[res][val].description}
                                subText={data[res][val].subText}
                                showMore={data[res][val].showMore}
                                image={data[res][val].image}
                                imageCover={data[res][val].imageCover}
                                video={data[res][val].video}
                                link={data[res][val].link}
                                filter={data[res][val].filter}
                                points={data[res][val].points}
                                cards={data[res][val].cards}
                                highlights={data[res][val].highlights}
                                hashtag={data[res][val].hashtag}
                            />
                        );
                    }
                });
            })}

            <CommonComponent items={feedData} />
        </div>
    );

    return feedLayout;
};

export default FeedComponent;
